module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/slide_04-618fcfe84fa16510900e9fedc83e3b12.jpg";